module.exports = __webpack_public_path__ + "img/2.36f6fd48.png";